import React from 'react';
import { SubmissionPdf, useApi } from '@axiom/ui';
import { useParams } from 'react-router';

import { CandidateApi } from '../../api/candidate-api';
import { TaxonomyApi } from '../../api/taxonomy-api';
import { EnvUtil } from '../../utils/env-util';
import { useEngagementTalentData } from '../../hooks/useEngagementTalentData';
import { CandidateLegalTechSkillsApi } from '../../api/candidate-legal-tech-skills-api';

export const SubmissionPdfData = () => {
  const { submissionId } = useParams();

  if (!submissionId) {
    throw new Error('No submissionId provided');
  }

  const { accountId, submission, allCandidateOpps } = useEngagementTalentData();

  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  const allGroupedExperiences = useApi(
    ...allCandidateOpps.map(({ candidate: { id } }) =>
      CandidateApi.readCandidateGroupedExperiences(id, {
        submissionId,
      })
    )
  ).map(response => response.data);

  const allCandidateIds = allCandidateOpps.map(({ candidate: { id } }) => id);

  const allLegalTechnicalSkills = useApi(
    ...allCandidateOpps.map(({ candidate: { id } }) =>
      CandidateLegalTechSkillsApi.readLegalTechSkills(id)
    )
  ).map(response => response.data);

  return (
    <SubmissionPdf
      accountId={accountId ?? ''}
      submission={submission}
      candidateOpps={allCandidateOpps}
      allGroupedExperiences={allGroupedExperiences}
      clientUrl={EnvUtil.clientUrl}
      loginUrl={EnvUtil.loginUrl}
      taxonomy={taxonomy}
      allCandidateIds={allCandidateIds}
      allLegalTechnicalSkills={allLegalTechnicalSkills}
    />
  );
};
